{
    "Device_Filter_SectionHeader": "Type apparaat filteren",
    "Device_Filter_Dropdown_Label": "Type apparaat",
    "NAME": "ReportsFilterDeviceFilter"
}